<template>
    <div id="featured-home-page-b2b-block" class="home-page-b2b">
        <div class="container-xl">
            <div class="main-page-block">
                <div class="row">
                    <div class="col-12">
                        <h3>{{lang('home_page_b2b_cim')}}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <B2BInfoItem v-for="item in b2bInfos" :key="item.id"
                            :name="item.name"
                            :description="item.description"
                            :target_link="item.target_link"
                            :srcset="itemSrcset(item)" 
                            :src="imgSrc(item)"
                         />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import B2BInfoItem from '@/components/pagesComponents/homePageComponents/B2BInfoItem.vue'

export default {
    data(){
        return {
            b2bInfos: []
        }
    },
    components:{
        B2BInfoItem
    },
    methods:{
        getHomeB2BInfos(){
            let _this = this          

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/home_info?&where[0][0]=where&where[0][1]=status&where[0][2]=1',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {  
                
                if (response.data.status == true ){
                    _this.b2bInfos = response.data.home_info
                } else {
                    _this.b2bInfos = []
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            });
        },
        imgSrc(item){
            if (item.image){
                return item.image
            } else {
                return "no-image"
            }
        },
    },
    created(){
        this.getHomeB2BInfos()
    }
}
</script>